<template>
  <v-container fluid>
    <v-layout row wrap align-center class="py-3">
      <v-flex xs12 sm12 md12 style="margin-bottom: 30px;">
        <v-expansion-panel>
          <v-expansion-panel-content class="mycustomExpansionPanel">
            <template v-slot:actions>
              <v-icon large color="primary">$vuetify.icons.expand</v-icon>
            </template>
            <template v-slot:header>
              <div>
                <v-icon color="primary">search</v-icon>
                <span class="pl-2 subheading">Custom Search Panel</span>
              </div>
            </template>
            <v-layout row wrap align-center>
              <v-flex>
                <v-card class="px-3">
                  <v-layout row wrap align-center class="py-3">
                    <v-flex class="mx-3" xs12 sm12 md12>
                      <v-text-field
                        label="Registration Number"
                        prepend-icon="list"
                        v-model="searchParam.reg_no"
                        type="number"
                        single-line
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm12 md12 style="margin-top: 40px">
                      <v-layout justify-center row fill-height align-center>
                        <v-btn color="primary" large @click="getDataFromApi()"
                          >Search</v-btn
                        >
                      </v-layout>
                    </v-flex>
                  </v-layout>
                </v-card>
              </v-flex>
            </v-layout>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-flex>

      <v-flex xs12 sm12 md12>
        <v-card color="white">
          <v-layout row>
            <v-card flat>
              <v-card-text class="title">Special Form Fillup List</v-card-text>
            </v-card>
            <v-divider class="my-2" vertical></v-divider>
            <v-spacer />
            <v-btn dark color="indigo" @click="SpexportAsPDF()">Export as PDF</v-btn>
            <!-- {{  this.pagination.totalItems }} -->
          </v-layout>
        </v-card>
      </v-flex>

      <v-flex xs12 sm12 md12>
        <v-data-table
          :headers="headers"
          :items="formFillUpByAdminList"
          class="elevation-1"
          :total-items="pagination.totalItems"
          :pagination.sync="pagination"
          :loading="loading"
          :rows-per-page-items="pagination.rowsPerPageItems"
        >
          <template v-slot:items="props">
            <td class="text-xs-left">{{ props.item.reg_no }}</td>

            <td class="text-xs-left">{{ props.item.student.name }}</td>
            <td class="text-xs-left">{{ props.item.student.father_name }}</td>
            <td class="text-xs-left">{{ props.item.student.mother_name }}</td>
            <td class="text-xs-left">
              {{ formatted_date(props.item.student_confirmed_at) }}
            </td>
            <td class="justify-left  px-0">
              <v-btn
                v-if="props.item.teacher_confirm_status == 1"
                small
                @click="getformFillupDetelsbyID(props.item.id)"
                >Download Application Form</v-btn
              >
              <v-btn
                color="red"
                v-if="props.item.teacher_confirm_status == 1"
                small
                @click="cancelConfirmation(props.item)"
                style="color:white"
                >Cancel Application</v-btn
              >
            </td>
          </template>
          <template>
            <!-- v-slot:expand="props" -->
            <v-card flat>
              <v-card-text>Peek-a-boo!</v-card-text>
            </v-card>
          </template>
          <template v-slot:no-data></template>
        </v-data-table>
      </v-flex>
    </v-layout>
  </v-container>

  <!-- <pre>{{getSchema}}</pre>  -->
  <!-- <pre>{{ formFillUpByAdminList }}</pre> -->
</template>
<script>
import moment from "moment";
import common_login_getters from "../../mixin/common_login_getters";
import commonGet from "../../mixin/common_getters_mixin";
import commonExamYear from "../../mixin/exam_year_watch_mixin";

export default {
  mixins: [common_login_getters,commonGet,commonExamYear],
  name: "SpecialFormFillupList",
  components: {},

  data: () => ({
    pagination: {
      rowsPerPage: 10,
      rowsPerPageItems: [10, 50, 100],
    },
    totalDataItems: 0,
    loading: true,
    searchParam: {},
    search: "",

    headers: [
      { text: "Registration No", align: "left", value: "reg_no" },
      { text: "Name", align: "left", value: "name" },
      { text: "Father Name", align: "left", value: "father_name" },
      { text: "Mother Name", align: "left", value: "mother_name" },
      { text: "Confirmed Date", align: "left", value: "student_confirmed_at" },
      { text: "Actions", align: "left", sortable: false },
    ],

    dialog: false,
    studentData: "",
    examMaster: {},
    showexamMaster: false,
  }),

  computed: {
    getSchema() {
      return this.$store.getters.getAllExamMaster;
    },
    formFillUpByAdminList() {
      return this.$store.getters.formFillUpByAdminList.data;
    },
    getTadaByIDOfFormFillup() {
      return this.$store.getters.getTadaByIDOfFormFillup;
    },
  },

  created() {
    // this.getDataFromApi();
    this.searchParam.exam_year = this.getLoggedInYear.year;
    this.searchParam.exam_code = this.getLoggedInExam.code;
  },
  watch: {
    pagination() {
      this.getDataFromApi();
    },
    getExamInitiateId(val) {
      this.searchParam.exam_id = val;
      if (val) {
        this.getDataFromApi();
      }
    },
    getTadaByIDOfFormFillup() {
      window.open(this.getTadaByIDOfFormFillup);
    },
  },

  methods: {
    getformFillupDetelsbyID(option) {
      this.$store.dispatch("fetchStudentFormFillupDetailsByID", option);
    },
    cancelConfirmation(options) {
      this.$store
        .dispatch("cancelConfirmationAdmin", options)
        .then((response) => {
          this.getDataFromApi();
        });
    },
    setLimit() {
      const { sortBy, page, rowsPerPage } = this.pagination;
      this.searchParam.page = page;
      this.searchParam.limit = rowsPerPage;
      this.searchParam.sort = sortBy;
      this.searchParam.exam_id = this.getExamInitiateId;
      this.searchParam.search = this.search;
    },

    getDataFromApi() {
      this.loading = true;
      this.searchParam.exam_id = this.getExamInitiateId;
      this.setLimit();
      this.searchParam.display_type ='';
      console.log("searchParam", this.searchParam);
      this.$store
        .dispatch("fetchAllSpecialFormFillup", this.searchParam)
        .then((data) => {
          this.loading = false;
          this.pagination.totalItems = data.data.meta.total;
          console.log("pagination.totalItems", this.pagination.totalItems);
        });
    },

    SpexportAsPDF() {
      this.searchParam.display_type = 'export_pdf';
      this.$store.dispatch("downloadAdmitSP", this.searchParam)
      .then((result) => {
          const blob = new Blob([result], { type: "application/pdf" });

          const url = window.URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = url;
          this.searchParam.exam_year = this.getLoggedInYear.year;
          link.setAttribute(
            "download",
            `${this.searchParam.exam_code}_${this.searchParam.exam_year}-spacial_ff_list.pdf`
          );

          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          window.URL.revokeObjectURL(url);
        })
        .catch((error) => {
          console.error("Tanvir! Download failed", error);
        });
      ;
    },

    formatted_date(date) {
      return moment(date).format("DD-MM-YYYY");
    },
  },
};
</script>

<style scoped></style>
